import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { LoginComponent } from './login';
import { EnvNoticeModule } from '../../components/env-notice/env-notice.module';

@NgModule({
  declarations: [
    LoginComponent,
  ],
  imports: [
    IonicModule,
    EnvNoticeModule
  ],
  exports: [
    LoginComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class LoginComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/login/login.module.ts